
export class ApiConfig {
  private static instance: ApiConfig;
  private readonly apiUrl: string;

  private constructor() {
    // this.apiUrl = 'http://localhost:8787';
    this.apiUrl = 'https://front-inversiones-api.innovaccion.workers.dev';
    // import.meta.env.DEV 
    // ? 'http://localhost:8787' 
    // 'https://front-inversiones-api.innovaccion.workers.dev';
  }

  static getInstance(): ApiConfig {
    if (!ApiConfig.instance) {
      ApiConfig.instance = new ApiConfig();
    }
    return ApiConfig.instance;
  }

  getApiUrl(): string {
    return this.apiUrl;
  }
}
